import LOGIN_CN from './login/LOGIN_CN'

export const LOGIN = LOGIN_CN
